import { useEffect, useState } from "react";
import { fetchSettings, logoSrc } from "@/lib/settings";

// Merkezi logo: admin panelinden yüklenen logoyu her yerde otomatik gösterir.
export default function Logo({ className, alt = "RENKA", ...rest }) {
  const [src, setSrc] = useState("/renka-logo.png");
  useEffect(() => {
    const apply = (force) => fetchSettings(force).then((s) => setSrc(logoSrc(s))).catch(() => {});
    apply(false);
    const h = () => apply(true);
    window.addEventListener("renka-settings-updated", h);
    return () => window.removeEventListener("renka-settings-updated", h);
  }, []);
  return (
    <img src={src} alt={alt} className={className}
      onError={(e) => { e.currentTarget.src = "/renka-logo.png"; }} {...rest} />
  );
}
